import { useState } from "react";
import { applyTheme, currentTheme, type Theme } from "../theme";

/** Dark (default) and ivory (light) switch for the sidebar footer. */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(currentTheme);
  const next: Theme = theme === "dark" ? "ivory" : "dark";
  return (
    <button
      type="button"
      className="btn small theme-toggle"
      aria-label={`Switch to ${next === "ivory" ? "ivory (light)" : "dark"} theme`}
      onClick={() => {
        applyTheme(next);
        setTheme(next);
      }}
    >
      {theme === "dark" ? "Ivory theme" : "Dark theme"}
    </button>
  );
}
